module.exports = __webpack_public_path__ + "static/img/Die_Hard_Logo.19992b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/launch/Die_Hard_Logo.png
// module id = sTiv
// module chunks = 1